import {mapGetters} from 'vuex'
import { EventBusNotification } from '@/components/EventBusNotification.js'
import { solutionMixin } from '@/utils/solution-mixin'
//import Vue from 'vue';
//import CONFIG from '@/constants/config.js';

export var teamMixin = {
  mixins:[EventBusNotification, solutionMixin],
  watch: { 
  },
  
  data(){
    return{
      hasOpenTeamLeaderRequestNotification:false
    }
  },
  computed: {
    ...mapGetters('events',['selectedEventId','selectedEvent','hasSelectedEvent','team','teamId','teamMembers','teamLeader','teamMemberById']),
    ...mapGetters('settings',['userId']),
    ...mapGetters('websocket',['isOnline','hasLeaderChangeRequest','leaderChangeRequest']),

    teamLeaderId(){
      return this.teamLeader?this.teamLeader.id:null;
    },
    
    useMasterSlave(){
      return (this.selectedEvent)?this.selectedEvent.master_slave:false;
    },
    isTeamLeader(){
      return this.teamLeaderId== this.userId
    },
    //Is TeamLeader in Single Mode or TeamLeader in Multiplayer Mode
    isTeamLeaderInMasterSlaveModeOrIsSingleMode(){
      return (!this.useMasterSlave || (this.useMasterSlave && this.isTeamLeader));
    },
    isTeamLeaderInMasterSlaveMode(){
      return (this.useMasterSlave && this.isTeamLeader);
    },
    isSlaveInMasterSlaveMode(){
      return (this.useMasterSlave && !this.isTeamLeader);
    }
  },
  methods: {
    /**
     * Whether a slave in teamleader mode must wait for the master to check the spot in: info
     * spots, spots with a time limit that has not run out, password and QR checkins. Never for
     * played spots.
     */
    checkinBlockedForSlave(spot, timeLimitReached = false){
      if(!this.isSlaveInMasterSlaveMode || !spot || this.spotAlreadyTouched(spot)){
        return false;
      }
      return this.isInfoSpot(spot)
        || (this.spotHasAnswerTimeLimit(spot) && !timeLimitReached)
        || this.isCheckinTypePasswort(spot)
        || this.isCheckinTypeQr(spot);
    },
    createTeamLeaderChange(){
      this.$store.commit("websocket/START_TEAMLEADER_CHANGE_REQUEST");
    },
    resetTeamLeaderChange(){
      this.$store.commit("websocket/CLEAR_TEAMLEADER_CHANGE_REQUEST");
    },
    requestTeamleaderChange(){
      if(this.useMasterSlave){
        this.createTeamLeaderChange();
        this.$websocket.broadcast.leaderChangeRequest(this.userId);
        let teamMember=this.teamMemberById(this.teamLeaderId);
        if(teamMember){
          EventBusNotification.$emit('notify',this.$t('app_team_master_requested_change',{seconds:process.env.VUE_APP_TEAMLEADER_RESPONSE_TIME,leader_name:teamMember.name}),null,null,(parseInt(process.env.VUE_APP_TEAMLEADER_RESPONSE_TIME)+1),0,null,null,()=>{
            //onOutOfTime response
            this.notifyTeamleaderChanged(this.userId);
          });
          console.log('hasOpenTeamLeaderRequestNotification requestTeamleaderChange:',this.hasOpenTeamLeaderRequestNotification);
        }
      }
    },
    sendTeamleaderChangeAbort(){
      if(this.useMasterSlave){
        this.$websocket.broadcast.leaderChangeRequest(this.userId,true);
      }
    },
    notifyTeamleaderChanged(personId,confirmByUserResult=true){
      try{
          if(this.useMasterSlave){
            if(confirmByUserResult){
              this.setTeamLeader(personId).then(()=>{
                this.$websocket.broadcast.leaderChange(personId,confirmByUserResult);
                let teamMember=this.teamMemberById(personId);
                if(teamMember){
                  let label = (personId==this.userId)?this.$t('app_team_master_changed_to_me'):this.$t('app_team_master_changed_to',{leader_new_name:teamMember.name});
                  EventBusNotification.$emit('notify',label);
                }
                this.resetTeamLeaderChange();
              }).catch(ex=>{
                EventBusNotification.$emit('notify',this.$t('noInternetConnectionOk'));
                console.log(ex);
              });
            }else{
              this.$websocket.broadcast.leaderChange(personId,confirmByUserResult);
            }

            this.hasOpenTeamLeaderRequestNotification=false;
          }
        }catch(ex){
          console.log(ex);
        }
    },
    // a teamleader tells the teammates about a solve; everyone else sends nothing
    notifyMasterSlaveTeamPlayersForSolve(spot){
      try{
        if(this.isTeamLeaderInMasterSlaveMode && spot){
          this.$websocket.broadcast.solve(spot.id);
        }
      }catch(ex){
        console.log(ex);
      }
    },
    // a teamleader tells the teammates about a checkin; openInPopup makes them open the spot
    notifyMasterSlaveTeamPlayersForCheckin(spot, openInPopup=false){
      try{
        if(this.isTeamLeaderInMasterSlaveMode && spot){
          this.$websocket.broadcast.checkin(spot.id, openInPopup);
        }
      }catch(ex){
        console.log(ex);
      }
    },
    notifyTeamPhotoChanged(){
      try{
        this.$websocket.broadcast.teamPhotoChange(this.userId);
      }catch(ex){
        console.log(ex);
      }
    },
    notifyTeamNameChanged(){
      try{
        this.$websocket.broadcast.teamNameChange(this.userId);
      }catch(ex){
        console.log(ex);
      }
    },
    setTeamLeader(personId){
      return this.$store.dispatch('events/setTeamLeader',{
        'person_id':personId
      });
    },
    getTeamInfo(){
      return this.$store.dispatch('events/getTeamInfo',{});
    }
  }
}
